import update from 'immutability-helper'
import cloneDeep from 'lodash/cloneDeep'

export const reducer = (state, action) => {
  const {
    emailSubject,
    deals,
    id,
    contacts,
    templates,
    selectedTemplate,
    contactId,
    isChecked,
    followUpDate,
    contactIndex,
    files,
    fileName,
    templateBody,
    template,
    ccContacts
  } = action.payload
  let index
  switch (action.type) {
    case 'SET_DEALS':
      return { ...state, deals }
    case 'SELECT_GLOBAL_TEMPLATE': {
      const stateClone = cloneDeep(state)
      stateClone.contacts.forEach((contact, index) => {
        contact.email.subject = templateBody[index].subject || templateBody[index].title
        contact.email.template = selectedTemplate
        contact.email.templateBody = templateBody[index].content
      })
      return { ...stateClone, selectedTemplate }
    }
    case 'SET_TEMPLATES':
      return { ...state, templates }
    case 'REMOVE_DEAL': {
      index = state.deals.findIndex(d => d.id === id)
      return update(state, {
        deals: {
          $splice: [[index, 1]]
        }
      })
    }
    case 'SET_CONTACTS':
      return { ...state, contacts }
    case 'REMOVE_CONTACT': {
      index = state.contacts.findIndex(c => c.contactId === contactId)
      const newState = update(state, {
        contacts: {
          $splice: [[index, 1]]
        }
      })
      if (!newState.contacts.length) {
        return { ...newState, selectedTemplate: null }
      }
      return newState
    }
    case 'TOGGLE_CONTACT_DEAL': {
      index = state.contacts.findIndex(c => c.contactId === contactId)
      let dealIndex = state.contacts[index].dealsToFollowup.findIndex(d => d.id === id)
      let newState
      if (~dealIndex) {
        newState = update(state, {
          contacts: {
            [index]: {
              dealsToFollowup: {
                [dealIndex]: {
                  isChecked: { $set: isChecked }
                }
              }
            }
          }
        })
      } else {
        dealIndex = state.contacts[index].otherDealsToFollowUp.findIndex(d => d.id === id)
        if (~dealIndex) {
          newState = update(state, {
            contacts: {
              [index]: {
                otherDealsToFollowUp: {
                  [dealIndex]: {
                    isChecked: { $set: isChecked }
                  }
                }
              }
            }
          })
        }
      }
      return newState
    }
    case 'SET_CONTACT_FOLLOWUP_DATE': {
      index = state.contacts.findIndex(c => c.contactId === contactId)
      return update(state, {
        contacts: {
          [index]: {
            followUpDate: { $set: followUpDate }
          }
        }
      })
    }
    case 'SET_CONTACT_EMAIL_SUBJECT': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              subject: { $set: emailSubject }
            }
          }
        }
      })
    }
    case 'SET_CONTACT_EMAIL_FILES': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              files: { $set: [...state.contacts[contactIndex].email.files, ...files] }
            }
          }
        }
      })
    }
    case 'SET_CONTACT_EMAIL_TEMPLATE_BODY': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              templateBody: { $set: templateBody }
            }
          }
        }
      })
    }
    case 'SET_CONTACT_EMAIL_TEMPLATE': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              template: { $set: template },
              subject: { $set: template.label }
            }
          }
        }
      })
    }
    case 'REMOVE_FILE': {
      const arr = [...state.contacts[contactIndex].email.files]
      const index = arr.findIndex(f => f.name === fileName)
      if (~index) {
        arr.splice(index, 1)
      }
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              files: { $set: arr }
            }
          }
        }
      })
    }
    case 'SET_CONTACT_EMAIL_SENT': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            email: {
              sent: { $set: true }
            }
          }
        }
      })
    }
    case 'SET_FOLLOW_UP_DATE': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            hasFollowUpDate: { $set: true }
          }
        }
      })
    }
    case 'SET_CC_CONTACTS': {
      return update(state, {
        contacts: {
          [contactIndex]: {
            ccContacts: { $set: ccContacts }
          }
        }
      })
    }
    default:
      throw new Error()
  }
}
